import { render, staticRenderFns } from "./DiagnosticImageCategoryFilter.vue?vue&type=template&id=62930782"
import script from "./DiagnosticImageCategoryFilter.vue?vue&type=script&lang=js"
export * from "./DiagnosticImageCategoryFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports